// extracted by mini-css-extract-plugin
export var readonly = "_eb-1";
export var star = "_eb-0";